<mat-checkbox [formField]="chatForm.status" class="full-width">
  {{ 'chat_setting.status' | translate }}
</mat-checkbox>
@if (chatModel().status) {
  <mat-form-field class="full-width">
    <mat-label>{{ 'chat_setting.room_title' | translate }}</mat-label>
    <input [formField]="chatForm.room_title" matInput>
  </mat-form-field>
  <cropper-component [avatar]="chatModel().room_avatar" [page]="'chat_setting'"
                     [defaultRatio]="true" (sendImg)="getRoomAvatar($event)"
                     (cropperOpened)="openCropper($event)"></cropper-component>
  <br>
  <div class="choose-color">
    <mat-label>{{ 'chat_setting.room_color' | translate }}</mat-label>
    <fuse-material-color-picker (onValueChange)="onSettingsChange($event)" [(selectedBg)]="chatModel().room_color">
    </fuse-material-color-picker>
  </div>
}
